import { render } from "./EditInventoryStockModal.vue?vue&type=template&id=1ab57867"
import script from "./EditInventoryStockModal.vue?vue&type=script&lang=js"
export * from "./EditInventoryStockModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__